import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/users/transactions`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // Assuming JWT is used
          },
        });
        setTransactions(response.data);
      } catch (err) {
        console.error('Error fetching transactions:', err);
        setError('Failed to fetch transaction history.');
      }
    };

    fetchTransactions();
  }, []);

  useEffect(() => {
    // Scroll to the top of the page when the component loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        backgroundColor: '#f9f9f9',
        minHeight: '100vh',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          color: '#007bff',
          marginBottom: '20px',
          fontSize: '2rem',
          fontWeight: 'bold',
        }}
      >
        Transaction History
      </h1>
      {error && (
        <p
          style={{
            color: '#ff4500',
            textAlign: 'center',
            fontWeight: 'bold',
            marginBottom: '20px',
          }}
        >
          {error}
        </p>
      )}
      {transactions.length > 0 ? (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            margin: '0 auto',
            backgroundColor: '#ffffff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            overflow: 'hidden',
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: '#007bff',
                color: '#ffffff',
                textAlign: 'left',
              }}
            >
              <th style={{ padding: '12px', fontWeight: 'bold' }}>Date</th>
              <th style={{ padding: '12px', fontWeight: 'bold' }}>Amount</th>
              <th style={{ padding: '12px', fontWeight: 'bold' }}>Tokens Purchased</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => (
              <tr
                key={transaction.id}
                style={{
                  backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff', // Alternating row colors
                }}
              >
                <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>
                  {new Date(transaction.date).toLocaleString()}
                </td>
                <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>
                  ${Number(transaction.amount).toFixed(2)}
                </td>
                <td style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>
                  {transaction.tokens}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p
          style={{
            textAlign: 'center',
            color: '#666',
            fontSize: '1.2rem',
            marginTop: '20px',
          }}
        >
          No transactions found.
        </p>
      )}
      <button
        onClick={() => navigate('/dashboard')}
        style={{
          display: 'block',
          margin: '30px auto 0',
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: '#ffffff',
          border: 'none',
          borderRadius: '5px',
          fontSize: '1rem',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default TransactionHistory;